import { dismissOverlayInjectionByInternalInstance } from '@zyno-io/vue-foundation';
import { getCurrentInstance } from 'vue';
import { useRouter } from 'vue-router';

/** Where every emergency-calling marker in Talk points: the one screen that lists the fixes. */
export const TALK_OVERVIEW_PATH = '/admin/talk/overview';

/**
 * Walks the user to the ZynoTalk overview, closing the modal the marker was clicked in.
 *
 * The red markers all mean the same thing — emergency calling is broken, or a 911 call has left a
 * number in fan-out mode — and all of them are resolved in one place. Several sit inside a modal
 * (the number and extension editors flag the e911 location they've selected), and leaving that modal
 * stacked over the screen the user just asked for makes the click look like it did nothing, so the
 * navigation dismisses it. Outside a modal the dismissal is a no-op: it looks for an overlay in this
 * component's ancestry and finds none.
 *
 * Must be called from `setup` — it captures the calling component instance to find that overlay.
 */
export function useGoToTalkOverview() {
    const router = useRouter();
    const instance = getCurrentInstance();

    return () => {
        if (instance) dismissOverlayInjectionByInternalInstance(instance);
        router.push(TALK_OVERVIEW_PATH);
    };
}
